import React, { useCallback, useEffect, useState } from 'react';
import LayoutWithMap from 'containers/Base/LayoutWithMap';
import {
  regionActions,
  regionFilterActions,
  regionSelectors,
} from 'containers/Pages/Region/Region/index';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import useFilters from 'containers/Base/useFilters';
import PropTypes from 'prop-types';
import { detailOpenState, modalState, toggleModal } from 'reducers/ui';
import { PAGE_URLS } from 'utils/constants';
import { AdminAndAbove, userHasRole } from 'utils/helper/roles';
import { getUserRoles } from 'reducers/users';
import regionForm from './regionForm';

const Regions = ({ columns, filtersRequired, details, loading, filters }) => {
  // use state hooks
  const [regionGridApi, setRegionGridApi] = useState();
  const onMapSelectedRegionId = useSelector(
    state => regionSelectors.getSelectedRowID(state),
    shallowEqual,
  );
  //list
  const regionListData = useSelector(
    state => regionSelectors.getTransformedRegionList(state),
    shallowEqual,
  );
  const totalEntries = useSelector(
    state => regionSelectors.getTotalEntries(state),
    shallowEqual,
  );
  const filterValues = useSelector(
    state => regionSelectors.getFilters(state),
    shallowEqual,
  );
  const forceRefresh = useSelector(
    state => regionSelectors.getForceRefresh(state),
    shallowEqual,
  );
  const detailOpen = useSelector(state => detailOpenState(state), shallowEqual);
  const modalOpen = useSelector(state => modalState(state));
  const userRoles = useSelector(state => getUserRoles(state), shallowEqual);
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  //---------------------------Actions------------------------------
  const dispatch = useDispatch();
  const dispatchFetchRegionList = useCallback(
    ({ filters, from = 0 }) =>
      dispatch(regionActions.fetchGridList({ filters, from })),
    [dispatch],
  );
  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(PAGE_URLS.REGION.name)),
    [dispatch],
  );
  const onUpdate = filters => {
    dispatchFetchRegionList({
      filters,
    });
  };
  const gridAPIHandler = gridAPI => {
    setRegionGridApi(gridAPI);
  };
  useEffect(() => {
    const regionHighLight = onMapSelectedRegionId => {
      if (onMapSelectedRegionId !== null) {
        const node =
          regionGridApi && regionGridApi.getRowNode(onMapSelectedRegionId);
        // Go to the highlighted node
        regionGridApi &&
          regionGridApi.ensureNodeVisible(node, { position: 'top' });
        if (node) {
          if (!node.isSelected()) {
            node.setSelected(true);
          }
        }
      }
    };
    regionHighLight(onMapSelectedRegionId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onMapSelectedRegionId, regionGridApi]);
  return (
    <LayoutWithMap
      header={'Regions'}
      setGridAPI={gridAPIHandler}
      loading={loading}
      //data
      cols={columns}
      data={regionListData}
      fetchData={dispatchFetchRegionList}
      totalEntries={totalEntries}
      onUpdate={onUpdate}
      forceRefresh={forceRefresh}
      //filters
      filtersRequired={filtersRequired}
      filterValues={localFilterValues}
      filters={filters()}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            regionFilterActions.setFilterKey({ key: true });
            regionFilterActions.setFilters({ filters });
          },
        })
      }
      //details panel
      DetailComponent={details}
      forceOpenDetailPanel={detailOpen[PAGE_URLS.REGION.name]}
      //create and edit
      editable={userHasRole({
        userRoles: userRoles,
        requiredRoles: AdminAndAbove,
      })}
      FormComponent={regionForm}
      onEdit={modalOpen[PAGE_URLS.REGION.name]}
      toggleModal={dispatchToggleModal}
    />
  );
};
Regions.propTypes = {
  columns: PropTypes.array.isRequired,
  filtersRequired: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  filters: PropTypes.func,
  details: PropTypes.func,
};
export default Regions;
